export default interface ProductVariantPrice {
  id?: number;
  productVariantId?: number;
  pricePerUnit?: number;
  itemsPerUnit?: number;
  currencyId?: number;
  countryId?: number;
  priceType?: string;
  priceId?: number;
  unitOfMeasurement?: string;
}

export const empty: ProductVariantPrice = {
  pricePerUnit: 0,
  itemsPerUnit: 1
};